import * as React from "react";
const SvgFiRrFireExtinguisher = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-fire-extinguisher_svg__a)">
      <path
        fill="#062147"
        d="M12 3H7V2a1 1 0 0 0-2 0v1.046c-1.585.144-3.124.63-4.5 1.426A1.001 1.001 0 0 0 1.5 6.204a9 9 0 0 1 3.5-1.148v2.028A6.01 6.01 0 0 0 0 13v6.5C0 21.981 2.018 24 4.5 24h3c2.48 0 4.5-2.019 4.5-4.5V13a6.01 6.01 0 0 0-5-5.916V5h5a1 1 0 0 0 0-2m-2 10v6.5c0 1.378-1.122 2.5-2.5 2.5h-3a2.505 2.505 0 0 1-2.45-2H7a1 1 0 0 0 0-2H2v-5c0-2.206 1.794-4 4-4s4 1.794 4 4M23.19.463C22.673.06 22.016-.079 21.34.09l-4.408 1.293A2.72 2.72 0 0 0 15 3.999c0 1.21.78 2.265 1.946 2.62l4.434 1.317q.258.064.516.064c.464 0 .917-.154 1.293-.448A2.1 2.1 0 0 0 24 5.89V2.124c0-.654-.295-1.259-.81-1.662zM22 5.891l-.092.117-4.386-1.303A.73.73 0 0 1 17 4c0-.327.21-.609.51-.701l4.448-1.26a.1.1 0 0 1 .042.085z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-fire-extinguisher_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFireExtinguisher;
